/**
 * Convert Snake Case (e.g. "param_name") to Camel Case (e.g. "paramName")
 * @param str input string in Snake Case
 * @return output string in Camel Case
 */
export const snakeToCamel = (str: string): string => {
    if (!str || typeof str !== "string") return str;

    return str.toLowerCase().replace(/([-_][a-z])/g, (group) => group.toUpperCase().replace("-", "").replace("_", ""));
};

/**
 * Konvertiert Camel Case (z.B. "paramName") zu Snake Case (z.B. "param_name")
 * @param str Eingabetext in Camel Case
 * @return Ausgabetext in Snake Case
 */
export const camelToSnake = (str: string): string => {
    if (!str || typeof str !== "string") return str;

    return str.replace(/([A-Z])/g, (match) => `_${match.toLowerCase()}`).replace(/^_/, ""); // Entfernt führenden Unterstrich, falls vorhanden
};

/**
 * Capitalize the first character (e.g. "month" → "Month"); the rest stays unchanged.
 * @param value input string
 * @return capitalized string
 */
export const capitalize = (value: string): string => value.charAt(0).toUpperCase() + value.slice(1);

/**
 * Count the number of leading whitespace characters in a string.
 *
 * @param str input string
 * @return number of leading whitespace characters
 */
export function countLeadingWhitespace(str: string): number {
    return str.length - str.trimStart().length;
}

/**
 * Encode a file in a base64 string.
 *
 * @param file the file to encode
 * @return base64 encoded result
 */
export function getBase64(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve((reader.result as string).replace(/^data:(.*,)?/, "")); //remove reader prefix
        reader.onerror = (error) => reject(error);
    });
}

export const truncateText = (text: string, maxLength = 50): string => {
    if (!text || typeof text !== "string") return text;

    if (text.length <= maxLength) return text;

    return `${text.slice(0, maxLength - 3)}...`;
};

/**
 * Shortens a text to at most {@code maxLines} lines and {@code maxLength} characters, appending "..." when
 * something was cut. Lines are the text's own line breaks; wrapping in the UI is limited separately via CSS.
 */
export const truncateLinesAndText = (text: string, maxLines = 3, maxLength = 200): string => {
    if (!text || typeof text !== "string") return text;

    const lines = text.split("\n");
    const firstLines = lines.length > maxLines ? `${lines.slice(0, maxLines).join("\n")}...` : text;
    return truncateText(firstLines, maxLength);
};
